<script lang="ts" setup>
const props = defineProps({
  linkTitle: String,
  icon: {
    type: String,
    default: 'icon-signup'
  },
  size: {
    type: String,
    default: ''
  },
})
</script>

<template>
  <nuxt-link class="link" :class="props.size">
    <div class="link__title" v-if="props.linkTitle">{{ props.linkTitle }}</div>
    <div class="link__icon" v-if="props.icon">
      <svg-icon :name="props.icon" />
    </div>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: toRem(24) toRem(10);
  background-color: $color-brand-4_1;
  color: $color-white-1;
  transition: all 0.6s cubic-bezier(0.87, 0, 0.13, 1);

  &:hover {
    background-color: $color-gray-1;
  }

  &__icon {
    width: toRem(24);
    height: toRem(24);
    margin-left: toRem(13);
  }

  &.no-bg {
    background-color: transparent;
    color: $color-gray-1;
  }

  &.white {
    color: $color-gray-1;
    background-color: $color-white-1;
  }

  &.white2 {
    color: $color-gray-1;
    background-color: $color-white-2;
  }
}
</style>
